import advisor from '@/api/advisor'
import api from '@/api'
import { AppHolder } from '@/utils/app-holder'
import reflect from '@/utils/reflect-promise'
import { ADVISORY_ROLES } from '@/utils/roles'

export default {
  namespaced: true,
  state: {
    authenticated: false,
    isAdmin: false,
    profile: null
  },

  actions: {
    fetch (context, cached = true) {
      const { profile } = context.state
      if (cached && profile) {
        return Promise.resolve(profile)
      }

      return advisor.fetch()
        .then(data => {
          if (!data.roles.find(role => ADVISORY_ROLES.indexOf(role) > -1)) {
            return Promise.reject(new Error('not-admin'))
          }
          return advisor.fetchProfile()
            .then(profile => {
              context.commit('fetch', Object.assign(data, profile.profile))
            })
        })
    },

    authenticate (context, credentials) {
      return advisor.signIn(credentials)
        .then(data => AppHolder.store.dispatch('user/unauthenticate')
          .then(() => context.commit('authenticate', data)))
    },

    unauthenticate (context) {
      return reflect(advisor.signOut())
        .then(() => context.commit('unauthenticate'))
    },

    refreshToken (context) {
      return advisor.refreshToken()
        .then(data => context.commit('authenticate', data))
    },

    setUnauthenticated (context) {
      context.commit('unauthenticate')
    }
  },

  mutations: {
    fetch (state, data) {
      const adminStatus = data.roles.find(role => role === 'admin')

      state.isAdmin = Boolean(adminStatus)
      state.profile = data
    },

    authenticate (state, data) {
      AppHolder.store.commit('updateToken', data.expiresIn)
      localStorage.setItem('oauthToken', data.accessToken)
      localStorage.setItem('refreshToken', data.refreshToken)
      api.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('oauthToken')}`
      state.authenticated = true
    },

    unauthenticate (state) {
      localStorage.removeItem('oauthToken')
      localStorage.removeItem('refreshToken')
      api.defaults.headers.common['Authorization'] = null
      state.authenticated = false
      state.profile = null
    }
  },

  getters: {
    userName ({ profile }) {
      if (profile) {
        const {
          firstName,
          lastName,
          email
        } = profile

        return firstName ? `${firstName} ${lastName}` : email
      }

      return ''
    },
    isAuthenticated ({ authenticated }) {
      return authenticated
    }
  }
}
